import { pathgen } from 'object-path-generator';
import { useStoreActions } from "../../../store/store-context";
import { useMutationState } from "../useMutationState";
export const useDuplicateDraftTestIds = pathgen('useDuplicateDraftTestIds');
export const useDuplicateDraft = _ref => {
  let {
    onSuccess,
    biCode
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    mutate,
    isLoading
  } = useMutationState({
    mutationFn: draftId => api.draft.duplicate(draftId),
    onSuccess,
    withPageLoader: true,
    toasts: {
      successMessage: 'Draft duplicated successfully',
      successTestId: useDuplicateDraftTestIds.SuccessToast(),
      errorMessage: 'Failed to duplicate draft',
      errorTestId: useDuplicateDraftTestIds.ErrorToast()
    },
    biCode
  });
  return {
    duplicateDraft: mutate,
    isLoading
  };
};